import { rankItem, rankings } from "@tanstack/match-sorter-utils";

export const fuzzyFilter =  (text, filterValue) => {
    if (!filterValue) return true;
  
    const itemRank = rankItem(text, String(filterValue), {
      threshold: rankings.MATCHES,
    });
  
    return itemRank.passed; 
};
